import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:person-multiple',
      order: 70,
      title: '其他媒体业务',
    },
    name: 'AdOtherMediaBusiness',
    path: '/other-media-business',
    children: [
      {
        name: 'AdOtherMediaAccount',
        path: '/other-media-account',
        component: () =>
          import('#/views/other-media-business/account-list/index.vue'),
        meta: {
          icon: 'mdi:account-outline',
          title: '账户管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdOtherMediaApplyAccount',
        path: '/other-media-apply-account',
        component: () =>
          import('#/views/other-media-business/apply-account-list/index.vue'),
        meta: {
          icon: 'mdi:account-add-outline',
          title: '开户管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdOtherMediaAccountAssign',
        path: '/other-media-account-assign',
        component: () =>
          import('#/views/other-media-business/account-assign-list/index.vue'),
        meta: {
          icon: 'mdi:share-variant-outline',
          title: '账户分配',
          keepAlive: true,
        },
      },
      {
        name: 'AdOtherMediaAccountRecharge',
        path: '/other-media-account-recharge',
        component: () =>
          import('#/views/other-media-business/account-recharge/index.vue'),
        meta: {
          icon: 'mdi:account-multiple-plus-outline',
          title: '账户充值',
          keepAlive: true,
        },
      },
      {
        name: 'AdOtherMediaAccountClear',
        path: '/other-media-account-clear',
        component: () =>
          import('#/views/other-media-business/account-clear/index.vue'),
        meta: {
          icon: 'mdi:clear-circle-multiple',
          title: '账户清零',
          keepAlive: true,
        },
      },
      {
        name: 'AdOtherMediaServiceFeeConfig',
        path: '/other-media-service-fee-config',
        component: () =>
          import('#/views/other-media-business/service-fee-config/index.vue'),
        meta: {
          icon: 'mdi:settings-outline',
          title: '账户服务费',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
